import { useEffect, useState } from 'react';
import { useAuth } from '../useAuth';
import { businessServicesConfig } from '../../services';
import { updateGraphQLAuthHeader } from '../../services/graphql.service';
import { registry } from '../../features/extensions/instances';

export const useUpdateApiHeaders = (): {
  isHeadersUpdated: boolean;
} => {
  const { isAuthenticated, user } = useAuth();
  const [isHeadersUpdated, setIsHeadersUpdated] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      return;
    }

    businessServicesConfig.updateTokenGetter(
      () => `Bearer ${user.accessToken}`,
    );
    updateGraphQLAuthHeader(`Bearer ${user.accessToken}`);
    registry.initApiClient(`Bearer ${user.accessToken}`);

    setIsHeadersUpdated(true);
  }, [user?.accessToken, isAuthenticated]);

  return {
    isHeadersUpdated,
  };
};
